import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get('session_id');
    axios
      .post(`${API}/auth/session`, {}, { headers: { 'X-Session-ID': sessionId }, withCredentials: true })
      .then((res) => {
        window.history.replaceState(null, '', '/staff');
        navigate('/staff', { replace: true, state: { user: res.data } });
      })
      .catch((err) => {
        window.history.replaceState(null, '', '/staff');
        setError(err.response?.status === 403
          ? 'This Google account is not authorized for staff access.'
          : 'Sign-in failed. Please try again.');
      });
  }, [navigate]);

  if (!error) return <div className="min-h-screen pt-20" />;
  return (
    <div className="min-h-screen pt-32 px-4 text-center" data-testid="staff-auth-error">
      <p className="text-lg text-red-700 font-semibold mb-6">{error}</p>
      <button
        onClick={() => navigate('/staff', { replace: true })}
        data-testid="staff-auth-error-back-btn"
        className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
      >
        Back to Staff Sign-In
      </button>
    </div>
  );
};
